module.exports = __webpack_public_path__ + "static/img/img_3.59c9d99b.jpg";